import { createContext } from 'react';
import type { useWhatsNewProvider } from './useWhatsNewProvider.ts';

type WhatsNewContextValue = ReturnType<typeof useWhatsNewProvider>;

/**
 * {@link WhatsNewContext} tracks the product-updates panel.
 */
export const WhatsNewContext = createContext<WhatsNewContextValue | undefined>(undefined);
